import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getPartnersList = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/pmtpartner-list${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createPartner = (data, token) => {
  return axios.post(`${baseUrl}/pmtpartner`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const deletePartner = (id, token) =>
  axios.delete(`${baseUrl}/pmtpartner/${id}`, {
    headers: {
      authorization: token,
    },
  });

export const updatePartner = (id, data, token) =>
  axios.patch(`${baseUrl}/pmtpartner/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getPartnerById = (id, token) =>
  axios.get(`${baseUrl}/pmtpartner/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getPartnerSignedAgreement = (id, token) => {
  let url = `${baseUrl}/downloadPartnerSignedfile/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const getFinalAgreement = (id, token) => {
  let url = `${baseUrl}/downloadFinalfile/${id}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
export const postUploadFinalAgreement = (myFile, id, token) => {
  return axios.post(`${baseUrl}/uploadVerifiedfilebyAdmin/${id}`, myFile, {
    headers: {
      authorization: token,
    },
  });
};
////get dropdown partner list
export const getPartnersDropdownList = (token) => {
  let url = `${baseUrl}/pmtpartner-list`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
